import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';


@Component({
  selector: 'app-select-product',
  templateUrl: './select-product.component.html',
  styleUrls: ['./select-product.component.scss']
})
export class SelectProductComponent implements  OnDestroy {

  @Output() productTypeChange = new EventEmitter<any>();

  public items: any[] = [
    { name: 'Regular', value: 'regular' },
    { name: 'Premium', value: 'premium' },
    { name: 'Diesel', value: 'diesel' }
  ];

  public productType: any = [];
  productType$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.productType$ = this.sharedService.sharedProductType.subscribe(productType => {
      this.productType = productType;
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.productType$.unsubscribe();
  }

  changeProductType(event: any) {
    this.productType = event;
    this.sharedService.nextProductType = this.productType;
    this.productTypeChange.emit(this.productType);

  }

  isSelected(option: any): boolean {
    if (!this.productType || this.productType.length === 0) {
      return false;
    }
    // Handle both single and multiple selection
    const selectedValue = Array.isArray(this.productType) ? this.productType[0] : this.productType;
    return option.value === selectedValue || option.value === selectedValue?.value;
  }
}
